import Vue from 'vue'

const state = {
  // 新規アカウントの場合は、true
  // パスワード変更の場合は、false
  requireSetup: false
}

const getters = {
  get: state => state
}

const actions = {
  setFlag ({commit}, flag) {
    commit('setFlag', flag)
  }
}

const mutations = {
  setFlag (state, value) {
    Vue.set(state, 'requireSetup', value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
